import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { LeaveRequest } from './store/leave-request.model';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { IGenericResponse } from '../shared';
import moment from 'moment';
@Injectable({
    providedIn: 'root'
})
export class LeaveRequestService {
    private uri = `${environment.apiLocation}/LeaveRequest`;

    constructor(private http: HttpClient, private log: LoggingService) {}

    /*
    POST {{rootUrl}}/api/LeaveRequest
{
"UserRole": null,
"EmployeeListid": "80000018-1246815215",
"EmpAuthStartDate": "1/1/20",
"EmpAuthEndDate": "12/31/20"
}
*/
    public get(
        userId: string,
        userRole: number,
        startDate: Date,
        endDate: Date
    ): Observable<Array<LeaveRequest>> {
        this.log.verbose({
            type: 'LeaveRequestService:get',
            userId,
            userRole,
            startDate,
            endDate
        });
        return this.http
            .post<Array<LeaveRequest>>(this.uri, {
                UserRole: userRole,
                EmployeeListid: userId,
                EmpAuthStartDate: startDate,
                EmpAuthEndDate: endDate
            })
            .pipe(
                map(x => x.map(lr => ({...lr, EmpAuthStartDate: moment(lr.EmpAuthStartDate).toDate(), EmpAuthEndDate: moment(lr.EmpAuthEndDate).toDate()}))),
                tap(data =>
                    this.log.verbose({
                        type: 'LeaveRequestService:get',
                        data
                    })
                )
            );
    }

    public put(
        requests: Array<LeaveRequest>
    ): Observable<IGenericResponse<LeaveRequest>> {
        this.log.verbose({ type: 'LeaveRequestService:put', requests });
        return this.http
            .put<IGenericResponse<LeaveRequest>>(this.uri, {
                LeaveRequestList: requests
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'LeaveRequestService:put:resp',
                        data
                    })
                )
            );
    }
    public delete(
        requests: Array<Partial<LeaveRequest>>
    ): Observable<IGenericResponse<LeaveRequest>> {
        this.log.verbose({ type: 'LeaveRequestService:delete', requests });
        return this.http.request<IGenericResponse<LeaveRequest>>(
            'DELETE',
            this.uri,
            {
                body: { EntityIDs: requests.map(x => x.AuthRequestID) }
            }
        );
    }
}
